import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Page from '../views/page.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/page/parkOverview'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path:'/page',
    name:'Page',
    redirect:'/page/parkOverview',
    component:Page,
    children:[
      {
        name:'园区风采',
        path:'parkOverview',
        component:()=>import('../views/page/parkOverview.vue'),
      },
      {
        name:'数据监测',
        path:'dataMonitoring',
        component:()=>import('../views/page/dataMonitoring.vue'),
      },
      // {
      //   name:'园区监控',
      //   path:'seedlingMonitoring',
      //   component:()=>import('../views/page/seedlingMonitoring.vue')
      // },
      // {
      //   name:'仓储物流',
      //   path:'warehouseLogistics',
      //   component:()=>import('../views/page/warehouseLogistics.vue')
      // }
    ]
  },
  {
    name:'园区监控',
    path:'/seedlingMonitoring',
    component:()=>import('../views/page/seedlingMonitoring.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
